import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "sports-menu" }
const _hoisted_2 = ["id", "name", "checked", "onInput"]
const _hoisted_3 = { class: "sport-label" }

import { ComputedRef, computed, inject, withDefaults, toRefs } from 'vue'
  import { useI18n } from 'vue-i18n'

  import { ISport, ITranslatedSport } from '@/types/sports'
  import { translateSports } from '@/utils/sports'

  interface Props {
    userSports: ISport[]
    selectedSportIds?: number[]
  }
  
export default /*#__PURE__*/_defineComponent({
  props: {
    userSports: null,
    selectedSportIds: { default: () => [] }
  },
  emits: ['selectedSportIdsUpdate'],
  setup(__props: any, { emit }) {

const props = __props as { userSports: ISport[], selectedSportIds: number[] }

  

  

  const { t } = useI18n()

  const sportColors = inject('sportColors')
  const { selectedSportIds } = toRefs(props)
  const translatedSports: ComputedRef<ITranslatedSport[]> = computed(() =>
    translateSports(props.userSports, t)
  )

  function updateSelectedSportIds(sportId: number) {
    emit('selectedSportIdsUpdate', sportId)
  }

return (_ctx: any,_cache: any) => {
  const _component_SportImage = _resolveComponent("SportImage")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(translatedSports), (sport) => {
      return (_openBlock(), _createElementBlock("label", {
        type: "checkbox",
        key: sport.id,
        style: _normalizeStyle({ color: sport.color ? sport.color : _unref(sportColors)[sport.label] })
      }, [
        _createElementVNode("input", {
          type: "checkbox",
          id: sport.id,
          name: sport.label,
          checked: _unref(selectedSportIds).includes(sport.id),
          onInput: ($event: any) => (updateSelectedSportIds(sport.id))
        }, null, 40, _hoisted_2),
        _createVNode(_component_SportImage, {
          "sport-label": sport.label,
          color: sport.color
        }, null, 8, ["sport-label", "color"]),
        _createElementVNode("span", _hoisted_3, _toDisplayString(sport.translatedLabel), 1)
      ], 4))
    }), 128))
  ]))
}
}

})